import { mapState } from 'vuex';
import _ from 'lodash';
//import $ from 'jquery';
import Swal from 'sweetalert2';

import {
  TrainingCampRouteInfoMixin
} from '@/scripts/TrainingCamp/TrainingCamp/mixins/TrainingCampRouteInfoMixin';

export default {
  name: 'TaskItem',

  mixins: [TrainingCampRouteInfoMixin],

  props: {
    p_task: {
      type: Object,
      default: () => ({}),
    },

    p_getDurationStringText: {
      type: Function,
      default: () => null,
    },
  },

  computed: {
    ...mapState('TrainingCamp/TrainingCamp', {
      ms_selectedFileId: 'selectedFileId',
    }),
  },

  methods: {
    warnNotCanAccess() {
      Swal.fire({
        width: '400px',
        backdrop: false,
        icon: 'warning',
        title: `没有权限`,
        text: '亲爱的学员，您还没有购买该课程或当前的班型没有权限，请购买课程或升级班型后再来吧~',
        showConfirmButton: false,
        timer: 3000,
      });
    },

    checkAccessAndOpenPlayer(bullet) {
      if (!bullet.canAccess) {
        this.warnNotCanAccess();
        return false;
      }
      this.$emit('open-player', bullet);
    },

    go2Practice(subject) {
      if (!subject.canAccess) {
        this.warnNotCanAccess();
        return false;
      }
      this.$emit('go-2-practice', subject);
    },

    generatePDF(taskId, bookId, fileId) {
      this.$emit('generate-pdf', taskId, bookId, fileId);
    },
  },
};
